import CreditNoteForm from "./CreditNoteForm";

function CreditNoteCreate() {
  return <CreditNoteForm mode="create" />;
}

export default CreditNoteCreate;
